import { routes } from '@redwoodjs/router'

import { parseViewUuidFromSearch, VIEW_UUID_QUERY_PARAM } from './parseViewUuidFromSearch'

/** Query param for deep-linking to a saved table view on the staff records list. */
export const RECORDS_LIST_VIEW_UUID_QUERY_PARAM = VIEW_UUID_QUERY_PARAM

export const parseRecordsListViewUuidFromSearch = parseViewUuidFromSearch

export const recordsListPathWithViewUuid = ({
  recordTypeId,
  viewUuid,
}: {
  recordTypeId: number
  viewUuid: string
}) => {
  const path = routes.recordsList({ recordTypeId })
  const params = new URLSearchParams({ [RECORDS_LIST_VIEW_UUID_QUERY_PARAM]: viewUuid })
  return `${path}?${params.toString()}`
}
